import { usePostTablesInventoryDevices } from '@ipfabric/api-client/client/model/devices/devices';
import { usePostTablesInventoryInterfaces } from '@ipfabric/api-client/client/model/interfaces/interfaces';
import { toInventoryInterfaceFilter } from '@ipfabric/utils/schema/labels/toInventoryInterfaceFilter';
import type { Filters } from '@ipfabric/utils/table/filters/filters';
import type { RuleTargetType } from '../ruleTypes';
import { RULE_TEST_COLUMNS } from './ruleFormSchema';

const TEST_PAGINATION = { start: 0, limit: 25 };

const inventoryTestQueryInput = <TColumn extends string>(
  columns: readonly TColumn[],
  snapshot: string,
  filters: Filters,
) => ({
  columns: [...columns],
  pagination: TEST_PAGINATION,
  snapshot,
  filters,
});

export const useTestRuleQueries = ({
  type,
  snapshotId,
  matchedFilters,
  unmatchedFilters,
}: {
  type: RuleTargetType;
  snapshotId: string | null | undefined;
  matchedFilters: Filters;
  unmatchedFilters: Filters;
}) => {
  const snapshot = snapshotId ?? '$last';
  const devicesEnabled = !!snapshotId && type === 'device';
  const interfacesEnabled = !!snapshotId && type === 'intL2';

  const matchedDevicesQuery = usePostTablesInventoryDevices(
    inventoryTestQueryInput(RULE_TEST_COLUMNS.device, snapshot, matchedFilters),
    { query: { enabled: devicesEnabled } },
  );
  const unmatchedDevicesQuery = usePostTablesInventoryDevices(
    inventoryTestQueryInput(
      RULE_TEST_COLUMNS.device,
      snapshot,
      unmatchedFilters,
    ),
    { query: { enabled: devicesEnabled } },
  );
  const matchedInterfacesQuery = usePostTablesInventoryInterfaces(
    inventoryTestQueryInput(
      RULE_TEST_COLUMNS.intL2,
      snapshot,
      toInventoryInterfaceFilter(matchedFilters),
    ),
    { query: { enabled: interfacesEnabled } },
  );
  const unmatchedInterfacesQuery = usePostTablesInventoryInterfaces(
    inventoryTestQueryInput(
      RULE_TEST_COLUMNS.intL2,
      snapshot,
      toInventoryInterfaceFilter(unmatchedFilters),
    ),
    { query: { enabled: interfacesEnabled } },
  );

  return type === 'intL2'
    ? {
        matchedQuery: matchedInterfacesQuery,
        unmatchedQuery: unmatchedInterfacesQuery,
      }
    : {
        matchedQuery: matchedDevicesQuery,
        unmatchedQuery: unmatchedDevicesQuery,
      };
};
